export const locations = {
  countries: {
    get_all: "accounts/country/",
    get_by_id: (id: number) => `accounts/country/get-by/?id=${id}`,
    create: "accounts/country/",
    update: (id: number) => `accounts/country/?id=${id}`,
    delete: (id: number) => `accounts/country/?id=${id}`,
  },
  cities: {
    get_all: (countryId: number) => `accounts/city/?id=${countryId}`,
    get_by_id: (id: number) => `accounts/city/get-by/?id=${id}`,
    create: "accounts/city/",
    update: (id: number) => `accounts/city/?id=${id}`,
    delete: (id: number) => `accounts/city/?id=${id}`,
  },
};
